import React from 'react'
import Menu from '../component/Menu';
import HeaderCasestudy from '../component/HeaderCasestudy';
import Casestudybody from '../component/Casestudybody32';
import Footer from '../component/Footer'
import { Helmet } from 'react-helmet';

const CaseStudy32 = ({setBlank}) => {
     
    const headings = "<h2 style='display:inline-block;color:#ffffff;'>Joint Venture Proposal </h2><h4>for a Infrastructure-Focused Investment fund</h4>";

  return (
    <>
        <Helmet>
        <title>Joint Venture Proposal for a Infrastructure-Focused Investment fund</title>
        <meta property="og:title" content="Joint Venture Proposal for a Infrastructure-Focused Investment fund" />
        <meta property='og:description' content='Joint Venture Proposal for a Infrastructure-Focused Investment fund'/>
        <meta name='keywords' content=''/>
        </Helmet>

        <Menu setBlank={setBlank}  />
        <HeaderCasestudy class="header-casestudy32" headings={headings} />  
        <Casestudybody />
        <Footer setBlank={setBlank} />
    </>
  )
}

export default CaseStudy32 
